import {useMutation} from "@tanstack/react-query";

import {editClientNoteMutationOptions} from "./edit-client-note.mutation-options";

export function useEditClientNote(clientId: string, noteId: number) {
  return useMutation(editClientNoteMutationOptions(clientId, noteId));
}
